import React from 'react'
import BannerForm from './form'
import BannerList from './list'
import Title from '@components/title'

const Banner = () => {
  return (
    <>
      <Title textone="Banner" texttwo="Settings" />
      <br />
      <BannerForm />
      <BannerList />
    </>
  )
}

export default Banner
